var _circle, _circle2, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 464,
    viewBox: "0 0 409 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.7146,
    cy: 69.9002,
    r: 68.7588,
    fill: "#D9E3BC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.108,
    cy: 385.601,
    r: 68.7588,
    fill: "#D9E3BC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 310.392,
    y: 0.39563,
    width: 89.9262,
    height: 499.794,
    rx: 44.9631,
    transform: "rotate(34.2973 310.392 0.39563)",
    fill: "#8CA1E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.322 228.365V117.502H80.1448L6.23605 230.675V260.007H76.2184V290.263H108.322V260.007H133.96V228.365H108.322ZM42.4975 228.365L75.9874 177.322V228.365H42.4975ZM204.447 114.961C165.645 114.961 138.853 146.372 138.853 203.883C138.853 261.162 165.645 292.804 204.447 292.804C242.787 292.804 269.81 261.162 269.81 203.883C269.81 146.372 242.787 114.961 204.447 114.961ZM204.447 146.603C224.541 146.603 233.548 166.466 233.548 203.883C233.548 241.299 224.541 261.162 204.447 261.162C184.122 261.162 175.114 241.299 175.114 203.883C175.114 166.466 184.122 146.603 204.447 146.603ZM377.905 228.365V117.502H349.727L275.818 230.675V260.007H345.801V290.263H377.905V260.007H403.542V228.365H377.905ZM312.08 228.365L345.57 177.322V228.365H312.08Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.83c6ae38f7af51406368c8a0bec6831e.svg";
export { ForwardRef as ReactComponent };